import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50 border-b border-background-200/70 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="container-site flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2">
          <span className={`text-xl md:text-2xl font-heading font-bold transition-colors duration-300 ${
            scrolled || !isHome ? 'text-primary-600' : 'text-background-50'
          }`}>
            新金瓶梅
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
              location.pathname === '/'
                ? scrolled || !isHome ? 'text-primary-600 bg-primary-50' : 'text-background-50 bg-white/20'
                : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50' : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
                location.pathname === `/category/${cat.slug}`
                  ? 'text-primary-600 bg-primary-50'
                  : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50' : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
              location.pathname === '/about'
                ? 'text-primary-600 bg-primary-50'
                : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50' : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
            scrolled || !isHome ? 'text-foreground-800' : 'text-background-50'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="container-site py-4 flex flex-col gap-1">
            <Link to="/" className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors">首页</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors">{cat.name}</Link>
            ))}
            <Link to="/about" className="px-4 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors">关于我们</Link>
          </div>
        </div>
      )}
    </header>
  );
}